import { Controller } from '@hotwired/stimulus'

// UX S2 instant tick (concept §3.3): a change submits the form at once (Turbo answers with the card and a toast).
// I-UX-S2-06 live list filter: typing submits after a pause (submitLater), a select, checkbox or picked date at once
// (changed); a typed field's own change on blur adds nothing, a date field waits for its change.
// Live filter (I-AUDIT-03): `queue` submits after a typing pause; date inputs wait for their change (the page-wide
// date picker parses the Czech text on change, a half-typed date is no filter).
export default class AutosubmitController extends Controller<HTMLFormElement> {
  static override values = { delay: { type: Number, default: 300 } }
  declare readonly delayValue: number
  private timer: number | undefined

  submit(): void {
    this.cancel()
    this.element.requestSubmit()
  }

  submitLater(event: Event): void {
    if (!this.typed(event.target)) return

    this.cancel()
    this.timer = window.setTimeout(() => this.submit(), this.delayValue)
  }

  // The Historie změn form's name for submitLater (I-AUDIT-03).
  queue(event: Event): void {
    this.submitLater(event)
  }

  changed(event: Event): void {
    if (!this.typed(event.target)) this.submit()
  }

  cancel(): void {
    window.clearTimeout(this.timer)
    this.timer = undefined
  }

  override disconnect(): void {
    this.cancel()
  }

  // A text-like field (not a date: datepicker_controller.ts turns those into text fields that fire input per key).
  private typed(target: EventTarget | null): boolean {
    return target instanceof HTMLInputElement && ['text', 'search', 'number'].includes(target.type) && !target.hasAttribute('data-datepicker')
  }
}
